(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-bar"] && !Shopify.designMode) return;
  try {
    window.addEventListener('DOMContentLoaded', (event) => {
    const searchBarList = document.querySelectorAll('form.search-bar');
    Array.from(searchBarList).forEach((searchBar) => {
      const searchInput = searchBar.querySelector('.search-bar-input');
      const clearBtn = searchBar.querySelector('.clear-search-btn');
      if(searchInput?.value?.length > 0) {
        clearBtn?.classList.add('clear-search-btn-show')
      }
      searchInput?.addEventListener('input', ((e) => {
        const targetValue = e.target.value?.toLowerCase() || '';
        if(targetValue) {
          clearBtn?.classList.add('clear-search-btn-show')
        }else {
          clearBtn?.classList.remove('clear-search-btn-show')
        }
      }))
      clearBtn?.addEventListener('click', ((e) => {
        searchInput.value = ''
        clearBtn.classList.remove('clear-search-btn-show')
      }))
    });
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["social-login"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const tokenTypeMap = {
      google: 'id_token',
      facebook: 'access_token',
      apple: 'jwt_token'
    }
    const googleLoginBtn = document.querySelector('.social-login-google');
    const facebookLoginBtn = document.querySelector('.social-login-facebook');
    const appleLoginBtn = document.querySelector('.social-login-apple');
    const storeId = window.theme?.request?.shop_id;
    // 初始化SDK
    function initSDK(src, id){
      let js, fjs = document.getElementsByTagName('script')[0];
      if (document.getElementById(id)) {
        return;
      }
      js = document.createElement('script');
      js.id = id;
      js.src = src;
      js.defer = true;
      fjs.parentNode.insertBefore(js, fjs);
      return js;
    }

    // shopify 
    const MICAS_JAVA_SERVICE_V2 = 'https://api.themicas.com'
    const backendUrl = `${MICAS_JAVA_SERVICE_V2}/user/login/oauth/getShopifyMultipass`
    async function sendCodeToBackend(social, code) {
      if (!code) {
        throw new Error('code is empty')
      }
      const nonce = Math.random().toString(36).slice(-8);
      const params = new URLSearchParams(window.location.search);
      const return_url = params.get('return_url');
      const checkout_url = params.get('checkout_url');
      let return_to
      if (return_url) {
        return_to = decodeURIComponent(return_url);
      }
      if (checkout_url) {
        return_to = decodeURIComponent(checkout_url);
      }

      console.debug({
        social: social,
        storeId: storeId,
        os: 'onlineStore',
        code: code,
        nonce: nonce,
        return_to: return_to,
        tokenType: tokenTypeMap[social]
      })

      const res = await fetch(backendUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          social: social,
          storeId: storeId,
          os: 'onlineStore',
          identityToken: code,
          nonce: nonce,
          return_to: return_to,
          tokenType: tokenTypeMap[social]
        })
      })
      const data = await res.json();
      if (data.code !== 200 || !data?.data?.shopifyMultipass) {
        throw new Error('auth error')
      }
      return {
        email: data.data.email,
        multipassToken: data.data.shopifyMultipass,
        isNew: data.data.isNew,
      }
    }
    // multipassToken跳转处理
    function multipassTokenRedirect(multipassToken) {
      if (!multipassToken) {
        return
      }
      window.location.href = `${window.location.origin}${window.location.pathname}/multipass/${multipassToken}`
    }

    // facebook Client
    const FB_APP_ID = '1258918065853440';
    const FB_APP_VERSION = 'v22.0';
    const FB_SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';
    const FB_SDK_ID = 'facebook-jssdk';
    const FB_SCOPE = 'public_profile,email';
    window.fbAsyncInit = function() {
      FB.init({
        appId: FB_APP_ID,
        cookie: true,
        xfbml: true,
        version: FB_APP_VERSION
      });
    };
    initSDK(FB_SDK_URL, FB_SDK_ID);
    async function facebookCallback(accessToken) {
      try {
        facebookLoginBtn.classList.add('loading');
        // 发送给你的后端
        const data = await sendCodeToBackend('facebook', accessToken);
        multipassTokenRedirect(data.multipassToken)
      } catch (error) {
        console.debug(`facebook error`);
      } finally {
        facebookLoginBtn.classList.remove('loading');
      }
    }
    facebookLoginBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (typeof FB === 'undefined') {
        return;
      }
      FB.login((response) => {
        if (response.status === 'connected') {
          const accessToken = response.authResponse.accessToken;
          facebookCallback(accessToken).catch()
        }
      }, { scope: FB_SCOPE })
    })

    // google Client
    const GOOGLE_CLIENT_ID = '260104360524-frgeqlcvoh9vh6bs9j61daeg6oh8kg5g.apps.googleusercontent.com';
    const GOOGLE_SDK_URL = 'https://accounts.google.com/gsi/client';
    const GOOGLE_SDK_ID = 'google-jssdk';
    const GOOGLE_SCOPE = 'openid email profile';
    let googleClient = null;
    function createGoogleClient() {
      if (googleClient) {
        return googleClient;
      }
      if (!window.google || !window.google.accounts || !window.google.accounts.oauth2) {
        return null;
      }
      googleClient = window.google.accounts.oauth2.initCodeClient({
        client_id: GOOGLE_CLIENT_ID,
        scope: GOOGLE_SCOPE,
        ux_mode: 'popup',
        callback: googleCallback,
        error_callback: (err) => {
          console.debug('Google error:', err);
        }
      });
      return googleClient;
    }
    const googleSdkScript = initSDK(GOOGLE_SDK_URL, GOOGLE_SDK_ID);
    if (googleSdkScript) {
      googleSdkScript.addEventListener('load', () => {
        createGoogleClient();
      });
    }
    createGoogleClient();
    async function googleCallback(response) {
      const code = response.code;
      try {
        googleLoginBtn.classList.add('loading');
        const data = await sendCodeToBackend('google', code);
        multipassTokenRedirect(data.multipassToken)
      } catch (error) {
        console.debug(`google error`);
      } finally {
        googleLoginBtn.classList.remove('loading');
      }
    }
    googleLoginBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const activeGoogleClient = createGoogleClient();
      if (!activeGoogleClient) {
        console.debug('Google SDK not ready');
        return;
      }
      activeGoogleClient.requestCode();
    })

    // apple Client
    const APPLE_CLIENT_ID = 'com.micas.online';
    const APPLE_SDK_URL = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
    const APPLE_SDK_ID = 'apple-jssdk';
    const APPLE_SCOPE = 'name email';
    let appleClientReady = false;
    function initAppleClient() {
      if (appleClientReady) {
        return true;
      }
      if (!window.AppleID || !window.AppleID.auth || typeof window.AppleID.auth.init !== 'function') {
        return false;
      }
      window.AppleID.auth.init({
        clientId: APPLE_CLIENT_ID,
        scope: APPLE_SCOPE,
        redirectURI: `https://${theme.request.host}/social/apple/callback`,
        usePopup: true
      });
      appleClientReady = true;
      return true;
    }
    const appleSdkScript = initSDK(APPLE_SDK_URL, APPLE_SDK_ID);
    if (appleSdkScript) {
      appleSdkScript.addEventListener('load', () => {
        initAppleClient();
      });
    }
    initAppleClient();
    async function appleCallback() {
      try {
        const activeAppleRes = initAppleClient();
        if (!activeAppleRes) {
          console.debug('Apple SDK not ready');
          return;
        }
        appleLoginBtn.classList.add('loading');
        const response = await window.AppleID.auth.signIn();
        if (response?.authorization?.id_token){
          const data = await sendCodeToBackend('apple', response.authorization.id_token);
          multipassTokenRedirect(data.multipassToken)
        } else {
          throw new Error('apple id_token is empty')
        }
      } catch (error) {
        console.debug(`apple error`);
      } finally {
        appleLoginBtn.classList.remove('loading');
      }
    }
    appleLoginBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      appleCallback().catch();
    })
  })
  } catch(e) { console.error(e); }
})();

})();
